import { connect } from 'react-redux'

import { loadShippingAddresses } from '../../../actions/loadShippingAddresses'
import { getSelectedAddress, getShippingAddresses } from '../../../selectors/addressSelectors'
import { AddressSection } from './AddressSection'

const mapStateToProps = (state) => ({
  selectedAddress: getSelectedAddress(state),
  showChangeButton: getShippingAddresses(state)?.length > 1,
})

const AddressSectionContainer = connect(mapStateToProps, {
  loadShippingAddresses,
})(AddressSection)

export { AddressSectionContainer }
